import React, {Component} from "react";

import {
    claimBonusOffer,
    clearRequestState,
    fetchBonusInfo,
    fetchBonusOffers,
    fetchNextBonuses, setDisplayTermsForBonusConfigId,
    setLastSeenBonusOfferId
} from "./BonusActions";
import {BonusStoreState, RequestState} from "./BonusReducer";
import "./BonusPage.scss";
import {ActiveBonuses} from "./ActiveBonuses";
import {BonusOffers} from "./BonusOffers";
import {NextBonuses} from "./NextBonuses";
import {Redirect, Route, RouteComponentProps, Switch} from "react-router-dom";
import {BonusHistory} from "./BonusHistory";
import {t} from "../i18n";
import {BonusConfig, BonusOffer, BonusUpcomingOffer, CurrencyDefinition, Settings, UserBonusStatus, UserBonusView} from "../http/protocol";
import {fetchContent} from "../contenful/ContentfulActions";
import {ContentModelName} from "../contenful/types";
import UFO from "../assets/cow_ufo.png";
import BonusClaimedModal from "./BonusClaimedModal";
import getLoggedInRedirect from "../utils/LoggedInRedirect";

import {getLastSeenBonusOffer} from "../selectors/messages-selector";
import {setActiveCurrency} from "../user/UserActions";
import {Dispatch} from "redux";
import {withRouter} from "react-router";
import {connect, useDispatch} from "react-redux";
import {AppState} from "../RootReducer";
import {ContentTabLink, ContentTabs} from "../ui/AccountUI";
import {Modal} from "react-bootstrap";
import BonusTerms from "./BonusTerms";
import {MenuCloseButton} from "../ui/navigation/Menu";


interface State {
    loading:boolean | null;
    offers:BonusOffer[];
    active:UserBonusView[];
    next:BonusUpcomingOffer[];
    claimedBonus:UserBonusView;
    show:boolean;

}


export class BonusPage extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { loading:null, active:[], next:[], offers:[], show:false,claimedBonus:{}}
    }

    componentDidMount(): void {
        window.scroll(0,0)
        if(this.props.currencies) {
            this.setState({loading: true})
            this.handleFetch(this.props.fetchBonusInfo).then(()=>{
            this.setState({loading: false})
            })
        }
        this.markOffersAsSeen();
    }

    handleFetch(cb: any){
        return new Promise((resolve, reject)=>{
            resolve(cb()); 
        })
    }

    componentWillUnmount(){
        if( this.state.active.length === 0 &&
            this.state.next.length === 0 &&
            this.state.offers.length === 0){
            this.props.clearRequest();
        }
    }

    handleGoBack = () => {
        if(this.props.location.state && (this.props.location.state as any).fromDeposit) {
            this.props.settings && this.props.history.push(getLoggedInRedirect(this.props.settings, true));
        } else {
            this.props.history.push("/menu")
        }
    };
    markOffersAsSeen() {
        let offers = this.props.bonus.offers;
        if(offers && offers.length> 0) {
            let maxId = -1;
            offers.forEach(o => {
               if(o.id && o.id > maxId) {
                   maxId = o.id;
               }
           });
            let lastSeen = this.props.lastSeenBonusOfferId ?? -1;
            if(maxId > lastSeen) {
                this.props.setLastSeenBonusOfferId?.(maxId);
            }
        }
    }

    sameCurrencyCodes(c1: CurrencyDefinition[] = [], c2: CurrencyDefinition[] = []) {
        const c1a = c1.map(c => c.code)
        const c2a = c2.map(c => c.code)
        return c1a.length === c2a.length && c1a.every(v => c2a.indexOf(v) != -1);
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if(!this.sameCurrencyCodes(prevProps.currencies, this.props.currencies)) {
            this.props.fetchBonusInfo();
        }

        if(prevProps.bonus.offers !== this.props.bonus.offers && this.props.bonus.offers) {
            this.setState({offers:this.props.bonus.offers})
            this.markOffersAsSeen();
        }
        if(prevProps.bonus.activeBonuses !== this.props.bonus.activeBonuses && this.props.bonus.activeBonuses) {
            this.setState({active:this.props.bonus.activeBonuses})
        }
        if(prevProps.bonus.nextBonuses !== this.props.bonus.nextBonuses && this.props.bonus.nextBonuses) {

            this.setState({next: this.props.bonus.nextBonuses})
        }
    }

    async claimBonus(id?:number):Promise<UserBonusView> {
        if(id) {
            await this.props.claim(id).then((res) => {
                if(res.status === UserBonusStatus.RUNNING) {
                    this.setState({show:true, claimedBonus:res});
                }
            }).catch(e => console.log(e))
        }
        return {}
    }

    renderBonus() {
        const bonus:BonusStoreState = this.props.bonus;
        const ac:string|undefined = this.props.activeCurrency;
        const abs:RequestState|undefined = bonus.activeBonusesState;
        const nbs:RequestState|undefined = bonus.nextBonusesState;
        const os:RequestState|undefined = bonus.offerState;
        const firstOfferCurrency = bonus.offers && bonus.offers[0] && bonus.offers[0].currency || "";
        const firstNextCurrency = bonus.nextBonuses && bonus.nextBonuses[0] && bonus.nextBonuses[0].bonusConfig?.monetaryConfig && bonus.nextBonuses[0].bonusConfig?.monetaryConfig.currencyCode || "";
        const firstActiveCurrency = bonus.activeBonuses && bonus.activeBonuses[0] && bonus.activeBonuses[0].currency || "";
        if(this.state.loading !== null && this.state.loading === true) {
                return this.renderLoader()
        } else if(ac && abs == RequestState.OK && this.state.active.length > 0) {
            return <ActiveBonuses firstActiveCurrency={firstActiveCurrency}  activeCurrency={ac}  bonuses={this.state.active} setActiveCurrency={(cc:string) => this.props.setActiveCurrency(cc)}/>

        } else if (ac && os == RequestState.OK && this.state.offers.length > 0) {
            return <BonusOffers activeCurrency={ac} firstOfferCurrency={firstOfferCurrency} claimOfferStatus={bonus.claimOfferStatus} claim={(id) => this.claimBonus(id)} offers={this.state.offers} fetchBonusInfo={this.props.fetchBonusInfo} setActiveCurrency={(cc:string) => this.props.setActiveCurrency(cc)}/>

        } else if (
            ac &&
            this.state.next.length > 0 &&
            nbs == RequestState.OK
        ) {
            return <NextBonuses activeCurrency={ac} firstNextCurrency={firstNextCurrency}  bonuses={this.state.next} dbt={t("global.depositButton")} setActiveCurrency={(cc:string) => this.props.setActiveCurrency(cc)}/>

        } else if(abs === RequestState.OK && nbs === RequestState.OK && os === RequestState.OK &&
            this.state.active.length === 0 &&
            this.state.next.length === 0 &&
            this.state.offers.length === 0 &&
            !this.state.loading
        ){
            return (
                <div className={"row notFound-content"}>
                    <div className="notFound-wrapper">
                        <img className={"notFound"} src={UFO} alt={"Not found"}
                             style={{background: `url(${UFO}) no-repeat`, backgroundSize: 'cover'}}/>
                        {firstOfferCurrency.length > 0 && (
                            <>
                                <br/>
                                <p>{t("bonus.bonusOfferOther", {currencyCode:firstOfferCurrency})}</p>
                                <button onClick={(e) => {
                                    if(typeof this.props.setActiveCurrency === "function") {
                                        this.props.setActiveCurrency(firstOfferCurrency)
                                    }
                                }} className="btn btn-primary">{t("bonus.switch-button", {currencyCode:firstOfferCurrency})}</button>
                            </>
                        )}
                        {
                            firstOfferCurrency.length === 0 &&(<p className={"notFound-text"}>{t("bonus.bonusOffersEmpty")}</p>)
                        }
                    </div>
                </div>
            )
        }

    }


    renderLoader() {
        return <div id="jsLoader" className="js-loader">
                    <div className="lds-facebook">
                        <div/>
                        <div/>
                        <div/>
                    </div>
                </div>
    }
    renderTermsModal() {
        return (
            <Modal show={!!this.props.displayTermsForBonusConfigId} size="lg"
                   aria-labelledby="contained-modal-title-vcenter"
                   onHide={()=> this.props.hideTerms?.()}
            >
                <Modal.Header>
                    <div className={"menu-close"} onClick={()=> this.props.hideTerms?.()}>
                        <MenuCloseButton />
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <BonusTerms bonusConfigId={this.props.displayTermsForBonusConfigId}/>
                </Modal.Body>
            </Modal>
        )
    }
    render() {

        if(!this.props.bonus){
            return <div/>
        }
        if(!this.props.loggedIn && this.props.loggedIn != undefined) {
            return <Redirect to={"/"} />
        }

        return (

            <>
                {this.renderTermsModal()}
                <ContentTabs>
                    <ContentTabLink to={"/account/bonus"} exact>
                        {t("bonus.menu.bonus-and-offers")}
                    </ContentTabLink>
                    <ContentTabLink to={"/account/bonus/history"} exact>
                        {t("bonus.menu.bonus-history")}
                    </ContentTabLink>
                </ContentTabs>
                <BonusClaimedModal claimedBonus={this.state.claimedBonus} show={this.state.show}/>
                <div className={"content-padding"}>
                    <Switch>
                        <Route exact path="/account/bonus">
                            {this.renderBonus()}
                        </Route>
                        <Route exact path={"/account/bonus/history"}>
                            {this.props.activeCurrency && <BonusHistory activeCurrency={this.props.activeCurrency}/>}
                        </Route>
                    </Switch>
                </div>
            </>

        )
    }
}


interface Props extends RouteComponentProps<{ section? : string }> {
    fetchBonusOffers() : any;
    fetchNextBonuses() : any;
    fetchBonusInfo() : any;
    clearRequest() : any,
    hideTerms () : void;
    claim( offerId? : number) : Promise<UserBonusView>;
    fetchContent(content:ContentModelName) : typeof fetchContent;
    setLastSeenBonusOfferId : (id : number) => void;
    setActiveCurrency(cc:String) : typeof setActiveCurrency;
    bonus : BonusStoreState;
    activeCurrency? : string;
    loggedIn?: boolean;
    currencies?:CurrencyDefinition[];
    settings?:Settings;
    lastSeenBonusOfferId?: number;
    displayTermsForBonusConfigId?: number;
}


const mapStateToProps = (appState : AppState) => {
    return {
        bonus : appState.bonus,
        activeCurrency : appState.user.activeCurrency,
        loggedIn : appState.user.user && appState.user.user.loggedIn,
        currencies : appState.settings.settings && appState.settings.settings.currencies,
        settings : appState.settings.settings,
        lastSeenBonusOfferId : getLastSeenBonusOffer(appState),
        displayTermsForBonusConfigId :  appState.bonus.displayTermsForBonusConfigId
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        fetchBonusOffers: () => dispatch(fetchBonusOffers() as any),
        fetchNextBonuses : () => dispatch(fetchNextBonuses() as any),
        fetchBonusInfo : () => dispatch(fetchBonusInfo() as any),
        claim : (offerId : number) => offerId && dispatch(claimBonusOffer(offerId) as any),
        fetchContent : (content:ContentModelName) => dispatch(fetchContent(content) as any),
        setLastSeenBonusOfferId : (id : number) => dispatch(setLastSeenBonusOfferId(id) as any),
        setActiveCurrency : (cc:string) => dispatch(setActiveCurrency(cc) as any),
        hideTerms : () => dispatch(setDisplayTermsForBonusConfigId()),
        clearRequest : () => dispatch(clearRequestState() as any)

    }
}


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BonusPage));